var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitcaseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25199",
    "data-name": "Group 25199",
    transform: "translate(-47 -300.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24800",
    "data-name": "Group 24800",
    transform: "translate(-1188.999 -21.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1235.999 321.909)",
    fill: "#396"
  })), /*#__PURE__*/React.createElement("g", {
    id: "suitcase",
    transform: "translate(53.309 305.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7340",
    "data-name": "Path 7340",
    d: "M11.32,4.134a.474.474,0,0,1-.474-.474V2.948h-1.9V3.66A.474.474,0,0,1,8,3.66V2.948A.949.949,0,0,1,8.948,2h1.9a.949.949,0,0,1,.948.948V3.66A.474.474,0,0,1,11.32,4.134Z",
    transform: "translate(-4.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7341",
    "data-name": "Path 7341",
    d: "M6.028,13.4a.977.977,0,0,1-.337.057,1.039,1.039,0,0,1-.365-.066L0,11.62v3.618a1.3,1.3,0,0,0,1.3,1.3h8.773a1.3,1.3,0,0,0,1.3-1.3V11.62Z",
    transform: "translate(0 -5.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7342",
    "data-name": "Path 7342",
    d: "M11.382,6.3V7.39L5.8,9.249a.351.351,0,0,1-.228,0L0,7.39V6.3A1.3,1.3,0,0,1,1.3,5h8.773A1.3,1.3,0,0,1,11.382,6.3Z",
    transform: "translate(0 -1.577)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseCircle);
export default __webpack_public_path__ + "static/media/suitcase-circle.6f1269bce149fe671eda6d6ec27dda66.svg";
export { ForwardRef as ReactComponent };